import Resource from './common/resource';

class contactsTasks extends Resource {
  path = 'contacts/tasks';
}

export default contactsTasks;
